module.exports = __webpack_public_path__ + "img/blanket.985e421b.svg";